import { WSInfoBox, WSList, WSText } from "@wingspanhq/fe-component-library";
import {
  SharedFileRequest,
  SharedFileRequestContextType
} from "@wingspanhq/wingspan-api-sdk";
import React from "react";

import { mimeTypesToGroups } from "../../../../../RequirementDefinitions/modules/SharedFile/createRequirementDefinition/utils";
import { useRequirementInstructionsModal } from "../../../../../Requirements/components/RequirementsDetails/useRequirementInstructionsModal";
import { RequirementCardContent } from "../../../../components/RequirementCardContent";

export const UploadNewFileInstructions = ({
  sharedFileRequest,
  requirementId
}: {
  sharedFileRequest: SharedFileRequest;
  requirementId: string;
}) => {
  const requirementInstructionsModal = useRequirementInstructionsModal();

  return (
    <WSList gap="M">
      {sharedFileRequest.instructions &&
      sharedFileRequest.contextType === SharedFileRequestContextType.NONE ? (
        <WSInfoBox>
          <WSText.ParagraphXs as="pre" color="gray600">
            {sharedFileRequest.instructions}
          </WSText.ParagraphXs>
        </WSInfoBox>
      ) : null}

      {sharedFileRequest.contextType !== SharedFileRequestContextType.NONE && (
        <WSInfoBox>
          Review the{" "}
          <a
            href="#"
            onClick={async () =>
              await requirementInstructionsModal.open({ requirementId })
            }
          >
            instructions
          </a>{" "}
          and upload your file
        </WSInfoBox>
      )}

      <RequirementCardContent
        description={
          <WSList gap="XS">
            <WSText.ParagraphXs color="gray600" weight="medium">
              Accepted formats:
            </WSText.ParagraphXs>
            {mimeTypesToGroups(sharedFileRequest.acceptedMimeTypes ?? []).map(
              typeDescription => (
                <WSText.ParagraphXs key={typeDescription} color="gray600">
                  {typeDescription}
                </WSText.ParagraphXs>
              )
            )}
            <WSText.ParagraphXs color="gray600">
              Max 100 MB per file
            </WSText.ParagraphXs>
          </WSList>
        }
        title="File not uploaded"
        type="documents"
      />
    </WSList>
  );
};
